import { useSyncExternalStore } from "react";
import { useNavigate } from "react-router-dom";
import UploadTrayView from "../common/UploadTrayView";
import { cancelFormUpload, clearFinishedFormUploads, getFormUploads, subscribeFormUploads } from "../../services/formUploadService";

/**
 * The bottom-right progress tray for form templates being uploaded and read by
 * the AI (the same tray Files and Investigations use). Mounted once in each
 * dashboard so it keeps showing as the officer moves between pages.
 */
const FormUploadTray: React.FC = () => {
  const items = useSyncExternalStore(subscribeFormUploads, getFormUploads);
  const navigate = useNavigate();
  return (
    <UploadTrayView
      items={items.map((i) => ({
        id: i.id,
        name: i.name,
        status: i.status,
        progress: i.progress,
        error: i.error,
        doneLabel: i.after,
        onOpen: i.openPath ? () => navigate(i.openPath!) : undefined,
      }))}
      onClearFinished={clearFinishedFormUploads}
      activeHint="Keep this tab open until the upload finishes. After that the form is read on our servers."
      finishedHint="Your forms are ready. Click a name to open it in the designer."
      finishedVerb="Finished"
      onCancel={cancelFormUpload}
    />
  );
};

export default FormUploadTray;
